<template>
	<bw-table
			aria-label="data-table"
			:display-filters="displayFilters"
			:headers="headers"
			hide-row-select
			:items="partners"
	>
		<template v-slot:item.created_at="{ item: partner }">
			{{ new Date(partner.created_at).toLocaleDateString() }}
		</template>
		<template v-slot:item.actions="{ item: partner }">
			<div class="d-flex justify-end">
				<v-btn
						color="secondary"
						depressed
						fab
						:href="editPartner(partner)"
						outlined
						small
				>
					<v-icon>
						mdi-pencil-outline
					</v-icon>
				</v-btn>
				<v-divider
						class="mx-2 my-1"
						vertical
				></v-divider>
				<v-btn
						color="accent"
						depressed
						fab
						:href="viewPartner(partner)"
						outlined
						small
				>
					<v-icon>
						mdi-clipboard-text-search
					</v-icon>
				</v-btn>
			</div>
		</template>
	</bw-table>
</template>

<script>
export default {
	name: 'Partners',
	props: {
		partnersData: {
			type: Array,
			default: () => []
		},
	},
	data() {
		return {
			displayFilters: {
				status: {
					name: 'Status',
					type: 'select',
					clearable: false,
					data: [
						{
							id: null,
							name: 'All Statuses',
						},
						{
							id: 'active',
							name: 'Active',

						},
						{
							id: 'inactive',
							name: 'Inactive',

						},
						{
							id: 'test',
							name: 'Test',
						}
					],
					default: 'active',
					filterOn: 'status',
					position: 'main',
				},
			},
			headers: [
				{
					align: 'start',
					mandatory: true,
					text: 'Name',
					value: 'name'
				},
				{
					align: 'start',
					selected: true,
					sortable: false,
					text: 'Created',
					value: 'created_at',
					width: 'auto'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '1%'
				}
			],
			partners: this.partnersData
		};
	},
	computed: {},
	created() {
	},
	methods: {
		editPartner(partner) {
			return `/super-admin-portal/partners/main/edit-partner/${partner.id}`
		},
		viewPartner(partner) {
			return `/super-admin-portal/partners/main/view-partner/${partner.id}`
		}
	}
};
</script>

<style lang="scss" scoped></style>
